import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

export const availableSerialNumber = (docData) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(-2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  // getDoc(doc(db, "masterData", "packageSetting")).then(async (docSnap) => {
  // if (docSnap.exists()) {
  //   const docData = docSnap.data();
  // Compare date with current date
  let newYear;
  let newMonth;
  let changeMonth = false;
  let changeYear = false;

  if (docData.currentYear === parseInt(year)) {
    if (docData.currentMonth === parseInt(month)) {
      newYear = year;
      newMonth = month;
    } else {
      newYear = year;
      newMonth = month;
      changeMonth = true;
    }
  } else {
    newYear = year;
    newMonth = month;
    changeYear = true;
  }
  console.log(
    `${year}-${month}${
      changeMonth || changeYear
        ? "1".padStart(6, "0")
        : docData.currentSerialId.toString().padStart(6, "0")
    }`,
    "in helper"
  );

  return `${year}-${month}${
    changeMonth || changeYear
      ? "1".padStart(6, "0")
      : docData.currentSerialId.toString().padStart(6, "0")
  }`;
  //   try {
  //     const docRef = await updateDoc(
  //       doc(db, "shelfConsolidatedPackages", consolidatePackageData?.id),
  //       {
  //         serialNumber:
  //           consolidatePackageData?.serialNumber ||
  //           `${year}-${month}${
  //             changeMonth || changeYear
  //               ? "1".padStart(6, "0")
  //               : docData.currentSerialId.toString().padStart(6, "0")
  //           }`,
  //         // dimensionH: newTotalValues.height,
  //         // dimensionL: newTotalValues.length,
  //         // dimensionW: newTotalValues.width,
  //         totalAmount: newTotalValues.totalAmount,
  //         totalWeight: newTotalValues.totalWeight,
  //         packageItemIds: newTotalValues.packageItemIds,
  //         packageShipmentStatus: "PREPARED",
  //         preparedShipmentDate: new Date(),
  //         merchantCount: newTotalValues.merchantCount,
  //       }
  //     ).then(() => {
  //       toast.success("Consolidated Successfully");
  //       if (!consolidatePackageData?.serialNumber) {
  //         updateDoc(doc(db, "masterData", "packageSetting"), {
  //           currentSerialId:
  //             changeMonth || changeYear
  //               ? 2
  //               : docData.currentSerialId + docData.incrementBy,
  //           currentYear: parseFloat(newYear),
  //           currentMonth: parseFloat(newMonth),
  //         });
  //       }
  //       getConsolidatePackageData();
  //     });
  //   } catch (e) {
  //     toast.error("Failed to Consolidate");
  //     console.error("Error adding document: ", e);
  //   }
  // }
  //   });
};

export const updateSerialNumber = async (docData) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(-2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  let newYear;
  let newMonth;
  let changeMonth = false;
  let changeYear = false;

  if (docData.currentYear === parseInt(year)) {
    if (docData.currentMonth === parseInt(month)) {
      newYear = year;
      newMonth = month;
    } else {
      newYear = year;
      newMonth = month;
      changeMonth = true;
    }
  } else {
    newYear = year;
    newMonth = month;
    changeYear = true;
  }

  await updateDoc(doc(db, "masterData", "packageSetting"), {
    currentSerialId:
      changeMonth || changeYear
        ? 2
        : docData.currentSerialId + docData.incrementBy,
    currentYear: parseFloat(newYear),
    currentMonth: parseFloat(newMonth),
  });
};

export const updatePackageColidationStatus = async(packageIds,data)=>{
  const updatedPackages = packageIds?.map(async(id)=>{
    const docRef = doc(db, "shelfPackages", id);
    const itemDoc = await updateDoc(docRef,data);
  })

  return await Promise.all(updatedPackages);
}